
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { chatCategories, ChatCategory } from '@/types/chatCategories';
import { Users, MapPin, MessageSquare, Briefcase, HelpCircle, Shield } from 'lucide-react';

interface ChatCategorySelectorProps {
  selectedCategory: ChatCategory | null;
  onCategorySelect: (category: ChatCategory | null) => void;
  isAdmin?: boolean;
}

const ChatCategorySelector = ({ selectedCategory, onCategorySelect, isAdmin = false }: ChatCategorySelectorProps) => {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'users': return <Users className="h-4 w-4" />;
      case 'map-pin': return <MapPin className="h-4 w-4" />;
      case 'message-square': return <MessageSquare className="h-4 w-4" />;
      case 'briefcase': return <Briefcase className="h-4 w-4" />;
      case 'help-circle': return <HelpCircle className="h-4 w-4" />;
      case 'shield': return <Shield className="h-4 w-4" />;
      default: return <MessageSquare className="h-4 w-4" />;
    }
  };

  const visibleCategories = chatCategories.filter(category => 
    !category.adminOnly || isAdmin
  );

  return (
    <div className="p-4 border-b border-gray-700">
      <h3 className="text-sm font-medium text-gray-400 mb-3">Chat Categories</h3>
      <div className="flex flex-wrap gap-2">
        <Badge
          variant={selectedCategory === null ? "default" : "outline"}
          className={`cursor-pointer transition-colors ${
            selectedCategory === null 
              ? 'bg-sports-green text-black hover:bg-sports-green/90' 
              : 'border-gray-600 text-gray-300 hover:bg-gray-700'
          }`}
          onClick={() => onCategorySelect(null)}
        >
          <MessageSquare className="h-3 w-3 mr-1" />
          All
        </Badge>
        
        {visibleCategories.map((category) => (
          <Badge
            key={category.id}
            variant={selectedCategory === category.id ? "default" : "outline"}
            className={`cursor-pointer transition-colors ${
              selectedCategory === category.id
                ? 'bg-sports-green text-black hover:bg-sports-green/90'
                : 'border-gray-600 text-gray-300 hover:bg-gray-700'
            }`}
            onClick={() => onCategorySelect(category.id)}
          >
            {getIcon(category.icon)}
            <span className="ml-1">{category.name}</span>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default ChatCategorySelector;
